import React from "react";
import "./Home.css";
import Logos from "../Logos";

export const Registration = () => {
  return (
    <div className="form-page-layout">
      <div className="form-layout">
        <iframe
          src="https://conference.ucc.ie/11th-international-conference-on-smart-computing-ieee-smartcomp-2025/registration/Site/Register"
          style={{ width: "100%", height: "600px" }}
        />
      </div>
    </div>
  );
};
